import React from 'react';
import Layout from "../../layout/Layout";
import PageHeaderBlock from "../../blocks/PageHeaderBlock";
import SEO from "../../components/seo";

import StepsBlock from "../../blocks/StepsBlock";
import SubmitApplicationBlock from "../../blocks/static/SubmitApplicationBlock";

import InfoCardsBlock from "../../blocks/InfoCardsBlock";

import enMessages from '../../i18n/escrowAccount/en.js'
import ruMessages from '../../i18n/escrowAccount/ru.js'

const messages = {
    en: enMessages,
    ru: ruMessages
}

const OnlineBankPage = ({ pathContext: { locale } }) => {
    return (
        <Layout locale={locale}>
            <SEO
                title={messages[locale].seo.title}
                description={messages[locale].seo.description}
            />
            <PageHeaderBlock
                locale={locale}
                title={messages[locale].pageHeaderBlock.title}
                text={messages[locale].pageHeaderBlock.text}
            />

            <InfoCardsBlock
                cardsTitle={messages[locale].infoCardsBlock.cardsTitle}
                cardsTitleColor="second"
                cardsLayout="row"
                cards={messages[locale].infoCardsBlock.cards}
                listTitle={messages[locale].infoCardsBlock.listTitle}
                list={messages[locale].infoCardsBlock.list}
                listPosition="afterCards"
                listColor="second"
                listAdditionalClass="baseList_theme_second_without_border"
                haveQuestions={false}
            />

            <InfoCardsBlock
                cardsTitle={messages[locale].infoCardsSecondBlock.cardsTitle}
                cardsTitleColor="first"
                cardsLayout="row"
                cards={messages[locale].infoCardsSecondBlock.cards}
                listTitle={messages[locale].infoCardsSecondBlock.listTitle}
                list={messages[locale].infoCardsSecondBlock.list}
                listPosition="afterCards"
                listColor="first"
                listAdditionalClass="baseList_theme_first_without_border"
                haveQuestions={false}
                config={{
                    baseBorder: true,
                    animation: '2'
                }}
            />

            <StepsBlock
                title={messages[locale].stepsBlock.title}
                color={messages[locale].stepsBlock.titleColor}
                list={messages[locale].stepsBlock.list}
                listColor="second"
                listType="ol"
            />

            <SubmitApplicationBlock
                title={messages[locale].submitApplicationBlock.title}
                textDescription={messages[locale].submitApplicationBlock.textDescription}
                textSubmit={messages[locale].submitApplicationBlock.textSubmitBottom || messages[locale].submitApplicationBlock.textSubmit}
            />

        </Layout>
    )
};

export default OnlineBankPage;
